import axios from './utils/axios';

export function get() {
  var url = '/awsiot/presigned-url';
  return axios.get(url);
}
//# sourceMappingURL=iot.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-api/lib/iot.js
// module id = 1080
// module chunks = 0